import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PrimaryTab from "./tabs/PrimaryTab";
import DetailTab from "./tabs/DetailTab";
import CommentsTab from "./tabs/CommentsTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';

function Form(props) {
    const history = useHistory();
    const formRefs = useRef({});
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        R_PROFILE: null,
        R_CUSTOMER: null,
        TRANSACTIONNUMBER: '',
        SHIPPERBOLNUMBER: '',
        R_PLANWAREHOUSE: null,
        R_PLANLOCATION: null,
        R_CARRIER: null,
        R_TRANSPORTCARRIER: null,
        R_EQUIPMENT: null,
        TRUCKREFERENCE: '',
        CONTAINER: '',
        EQUIPMENTINTERCHANGEREPORT: '',
        COMMENT: '',
        DELIVERYPICKUPPLANNEDDATETIME: null,
        DELIVERYPICKUPARRIVEDATETIME: null,
        DELIVERYPICKUPDEPARTDATETIME: null,
        TRUCKARRIVALDATETIME: null,
        TRUCKDEPARTDATETIME: null,
        TRANSPORTATIONYARDLEAVEDATE: null,
        PICKBYPLANDATE: null,
        LOADBYPLANDATE: null,
        R_UNLOADPICKBY: null,
        R_CHECKBY: null,
        R_PUTAWAYBY: null,
        R_LOADBY: null,
        R_PICKBY: null,
        R_STAGINGWAREHOUSE: null,
        R_STAGINGAREA: null,
        PLANNEDRECEIVEDSHIPPEDDATETIME: null,
        STAGINGSTARTDATE: null,
        STAGINGENDDATE: null,
        PLANCOMMENT: '',
        DELIVERYPICKUPCOMMENT: '',
        USERDEFINEDCODE1: null,
        USERDEFINEDCODE2: null,
        USERDEFINEDCODE3: null,
        USERDEFINEDCODE4: null,
        USERDEFINEDCODE5: null,
        USERDEFINEDCODE6: null,
        USERDEFINEDCODE7: null,
        USERDEFINEDCODE8: null,
        USERDEFINEDCODE9: null,
        USERDEFINEDCODE10: null,
        USERDEFINEDREFERENCE1: '',
        USERDEFINEDREFERENCE2: '',
        USERDEFINEDREFERENCE3: '',
        USERDEFINEDREFERENCE4: '',
        USERDEFINEDREFERENCE5: '',
        USERDEFINEDREFERENCE6: '',
        USERDEFINEDREFERENCE7: '',
        USERDEFINEDREFERENCE8: '',
        USERDEFINEDREFERENCE9: '',
        USERDEFINEDREFERENCE10: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const accessToken = props?.oidc?.user?.access_token;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const position = { of: '#accordion' };

    /** WMTransactionHeaderViewModel uses Shipperbolnumber; JSON may be camelCase or PascalCase. */
    const shipperBolFromApi = useCallback((dto) => {
        if (!dto || typeof dto !== 'object') return '';
        const v =
            dto.ShipperBolNumber ??
            dto.shipperBolNumber ??
            dto.Shipperbolnumber ??
            dto.shipperbolnumber;
        return v != null && v !== '' ? String(v) : '';
    }, []);

    const emptyGuid = '00000000-0000-0000-0000-000000000000';

    /** Plan warehouse / dock GUIDs from API (property name variants). */
    const guidFromApi = useCallback((dto, ...keys) => {
        if (!dto || typeof dto !== 'object') return null;
        for (let i = 0; i < keys.length; i++) {
            const v = dto[keys[i]];
            if (v != null && v !== '' && String(v) !== emptyGuid) {
                return v;
            }
        }
        return null;
    }, []);

    /** Plan From / Plan To (and similar) — tolerate JSON property casing. */
    const dateTimeFromApi = useCallback((dto, ...keys) => {
        if (!dto || typeof dto !== 'object') return null;
        for (let i = 0; i < keys.length; i++) {
            const v = dto[keys[i]];
            if (v !== undefined && v !== null && v !== '') return v;
        }
        return null;
    }, []);

    /** Text fields — read first defined JSON property (including empty string). */
    const stringFromApi = useCallback((dto, ...keys) => {
        if (!dto || typeof dto !== 'object') return undefined;
        for (let i = 0; i < keys.length; i++) {
            const v = dto[keys[i]];
            if (v !== undefined) return v == null ? '' : String(v);
        }
        return undefined;
    }, []);

    /** WMTransactionHeaderViewModel uses Userdefinedcode1…10; JSON may use other casings. */
    const userDefinedCodeFromApi = useCallback((dto, num) => {
        if (!dto || typeof dto !== 'object') return undefined;
        const keys = [
            `UserDefinedCode${num}`,
            `userDefinedCode${num}`,
            `Userdefinedcode${num}`,
            `userdefinedcode${num}`,
        ];
        for (let k = 0; k < keys.length; k++) {
            const v = dto[keys[k]];
            if (v !== undefined) {
                if (v === null || v === '') return null;
                return v;
            }
        }
        return undefined;
    }, []);

    /** UserDefinedReference1…10 on VM; entity JSON may use other casings. */
    const userDefinedReferenceFromApi = useCallback(
        (dto, num) =>
            stringFromApi(
                dto,
                `UserDefinedReference${num}`,
                `userDefinedReference${num}`,
                `Userdefinedreference${num}`,
                `userdefinedreference${num}`
            ),
        [stringFromApi]
    );

    const handleFieldChange = useCallback((name, value) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
    }, []);

    const loadScheduleById = useCallback(async (rowId) => {
        if (!rowId || rowId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionScheduleById}?rowId=${rowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data) {
                const schedule = response.data;
                setformFields({
                    ROWID: schedule.RowId || schedule.rowId || rowId,
                    R_PROFILE: schedule.RProfile || schedule.rProfile || null,
                    R_CUSTOMER: schedule.RCustomer || schedule.rCustomer || null,
                    TRANSACTIONNUMBER: schedule.TransactionNumber || schedule.transactionNumber || schedule.transactionnumber || '',
                    SHIPPERBOLNUMBER: shipperBolFromApi(schedule) || '',
                    R_PLANWAREHOUSE: guidFromApi(
                        schedule,
                        'RPlanWarehouse',
                        'rPlanWarehouse',
                        'RPlanwarehouse',
                        'rPlanwarehouse'
                    ),
                    R_PLANLOCATION: guidFromApi(
                        schedule,
                        'RPlanLocation',
                        'rPlanLocation',
                        'RPlanlocation',
                        'rPlanlocation'
                    ),
                    R_CARRIER: schedule.RCarrier || schedule.rCarrier || null,
                    R_TRANSPORTCARRIER: schedule.RTransportCarrier || schedule.rTransportCarrier || null,
                    R_EQUIPMENT: guidFromApi(
                        schedule,
                        'REquipment',
                        'rEquipment',
                        'requipment'
                    ),
                    TRUCKREFERENCE:
                        stringFromApi(
                            schedule,
                            'TruckReference',
                            'truckReference',
                            'truckreference'
                        ) ?? '',
                    CONTAINER: schedule.Container || schedule.container || '',
                    EQUIPMENTINTERCHANGEREPORT:
                        stringFromApi(
                            schedule,
                            'EquipmentInterchangeReport',
                            'equipmentInterchangeReport',
                            'equipmentinterchangereport'
                        ) ?? '',
                    COMMENT: schedule.Comment || schedule.comment || '',
                    DELIVERYPICKUPPLANNEDDATETIME: dateTimeFromApi(
                        schedule,
                        'DeliveryPickupPlannedDateTime',
                        'deliveryPickupPlannedDateTime',
                        'deliverypickupplanneddatetime'
                    ),
                    DELIVERYPICKUPARRIVEDATETIME: dateTimeFromApi(
                        schedule,
                        'DeliveryPickupArriveDateTime',
                        'deliveryPickupArriveDateTime',
                        'deliverypickuparrivedatetime'
                    ),
                    DELIVERYPICKUPDEPARTDATETIME: dateTimeFromApi(
                        schedule,
                        'DeliveryPickupDepartDateTime',
                        'deliveryPickupDepartDateTime',
                        'deliverypickupdepartdatetime'
                    ),
                    TRUCKARRIVALDATETIME: dateTimeFromApi(
                        schedule,
                        'TruckArrivalDateTime',
                        'truckArrivalDateTime',
                        'truckarrivaldatetime'
                    ),
                    TRUCKDEPARTDATETIME: dateTimeFromApi(
                        schedule,
                        'TruckDepartDateTime',
                        'truckDepartDateTime',
                        'truckdepartdatetime'
                    ),
                    TRANSPORTATIONYARDLEAVEDATE: dateTimeFromApi(
                        schedule,
                        'TransportationYardLeaveDate',
                        'transportationYardLeaveDate',
                        'transportationyardleavedate'
                    ),
                    PICKBYPLANDATE: dateTimeFromApi(
                        schedule,
                        'PickByPlanDate',
                        'pickByPlanDate',
                        'pickbyplandate'
                    ),
                    LOADBYPLANDATE: dateTimeFromApi(
                        schedule,
                        'LoadByPlanDate',
                        'loadByPlanDate',
                        'loadbyplandate'
                    ),
                    R_UNLOADPICKBY: guidFromApi(
                        schedule,
                        'RUnloadPickBy',
                        'rUnloadPickBy',
                        'runloadpickby'
                    ),
                    R_CHECKBY: guidFromApi(
                        schedule,
                        'RCheckBy',
                        'rCheckBy',
                        'rcheckby'
                    ),
                    R_PUTAWAYBY: guidFromApi(
                        schedule,
                        'RPutAwayBy',
                        'rPutAwayBy',
                        'rputawayby'
                    ),
                    R_LOADBY: guidFromApi(
                        schedule,
                        'RLoadBy',
                        'rLoadBy',
                        'rloadby'
                    ),
                    R_PICKBY: guidFromApi(
                        schedule,
                        'RPickBy',
                        'rPickBy',
                        'rpickby'
                    ),
                    R_STAGINGWAREHOUSE: guidFromApi(
                        schedule,
                        'RStagingWarehouse',
                        'rStagingWarehouse',
                        'rstagingwarehouse'
                    ),
                    R_STAGINGAREA: guidFromApi(
                        schedule,
                        'RStagingArea',
                        'rStagingArea',
                        'rstagingarea'
                    ),
                    PLANNEDRECEIVEDSHIPPEDDATETIME: schedule.PlannedReceivedShippedDateTime || schedule.plannedReceivedShippedDateTime || null,
                    STAGINGSTARTDATE: dateTimeFromApi(
                        schedule,
                        'StagingStartDate',
                        'stagingStartDate',
                        'stagingstartdate'
                    ),
                    STAGINGENDDATE: dateTimeFromApi(
                        schedule,
                        'StagingEndDate',
                        'stagingEndDate',
                        'stagingenddate'
                    ),
                    PLANCOMMENT:
                        stringFromApi(
                            schedule,
                            'PlanComment',
                            'planComment',
                            'Plancomment',
                            'plancomment'
                        ) ?? '',
                    DELIVERYPICKUPCOMMENT:
                        stringFromApi(
                            schedule,
                            'DeliveryPickupComment',
                            'deliveryPickupComment',
                            'Deliverypickupcomment',
                            'deliverypickupcomment'
                        ) ?? '',
                    ...Object.fromEntries(
                        Array.from({ length: 10 }, (_, idx) => {
                            const n = idx + 1;
                            return [
                                `USERDEFINEDCODE${n}`,
                                userDefinedCodeFromApi(schedule, n) ?? null,
                            ];
                        })
                    ),
                    ...Object.fromEntries(
                        Array.from({ length: 10 }, (_, idx) => {
                            const n = idx + 1;
                            return [
                                `USERDEFINEDREFERENCE${n}`,
                                userDefinedReferenceFromApi(schedule, n) ?? '',
                            ];
                        })
                    ),
                });
            }
        } catch (error) {
            console.error('Error loading schedule:', error);
            notify('Failed to load schedule data.', 'error', 3000);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken, shipperBolFromApi, guidFromApi, dateTimeFromApi, stringFromApi, userDefinedCodeFromApi, userDefinedReferenceFromApi]);

    useEffect(() => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadScheduleById(rowId);
        }
    }, [props.id, loadScheduleById]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoadPanelVisible(true);

        try {
            const shipperBolPayload = formFields.SHIPPERBOLNUMBER ?? '';
            const planWh = formFields.R_PLANWAREHOUSE || null;
            const planLoc = formFields.R_PLANLOCATION || null;
            const planFromDt = formFields.DELIVERYPICKUPPLANNEDDATETIME ?? null;
            const planToDt = formFields.DELIVERYPICKUPARRIVEDATETIME ?? null;
            const equipmentId = formFields.R_EQUIPMENT || null;
            const truckRef = formFields.TRUCKREFERENCE ?? '';
            const eir = formFields.EQUIPMENTINTERCHANGEREPORT ?? '';
            const yardArriveDt = formFields.DELIVERYPICKUPDEPARTDATETIME ?? null;
            const dockStartDt = formFields.TRUCKARRIVALDATETIME ?? null;
            const dockEndDt = formFields.TRUCKDEPARTDATETIME ?? null;
            const yardLeaveDt = formFields.TRANSPORTATIONYARDLEAVEDATE ?? null;
            const pickByDt = formFields.PICKBYPLANDATE ?? null;
            const loadByDt = formFields.LOADBYPLANDATE ?? null;
            const unloadPickById = formFields.R_UNLOADPICKBY || null;
            const checkById = formFields.R_CHECKBY || null;
            const putAwayById = formFields.R_PUTAWAYBY || null;
            const loadByWorkerId = formFields.R_LOADBY || null;
            const pickByWorkerId = formFields.R_PICKBY || null;
            const stagingWhId = formFields.R_STAGINGWAREHOUSE || null;
            const stagingAreaId = formFields.R_STAGINGAREA || null;
            const stagingStartDt = formFields.STAGINGSTARTDATE ?? null;
            const stagingEndDt = formFields.STAGINGENDDATE ?? null;
            const planComment = formFields.PLANCOMMENT ?? '';
            const deliveryPickupComment = formFields.DELIVERYPICKUPCOMMENT ?? '';
            const userDefinedCodeApiFields = {};
            for (let i = 1; i <= 10; i++) {
                const raw = formFields[`USERDEFINEDCODE${i}`];
                const val = raw === '' || raw === undefined ? null : raw;
                userDefinedCodeApiFields[`UserDefinedCode${i}`] = val;
                userDefinedCodeApiFields[`userDefinedCode${i}`] = val;
                userDefinedCodeApiFields[`Userdefinedcode${i}`] = val;
                userDefinedCodeApiFields[`userdefinedcode${i}`] = val;
            }
            const userDefinedReferenceApiFields = {};
            for (let i = 1; i <= 10; i++) {
                const val = formFields[`USERDEFINEDREFERENCE${i}`] ?? '';
                userDefinedReferenceApiFields[`UserDefinedReference${i}`] = val;
                userDefinedReferenceApiFields[`userDefinedReference${i}`] = val;
                userDefinedReferenceApiFields[`Userdefinedreference${i}`] = val;
                userDefinedReferenceApiFields[`userdefinedreference${i}`] = val;
            }
            const payload = {
                RowId: formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" ? formFields.ROWID : "00000000-0000-0000-0000-000000000000",
                RProfile: formFields.R_PROFILE || null,
                RCustomer: formFields.R_CUSTOMER || null,
                TransactionNumber: formFields.TRANSACTIONNUMBER || "",
                ShipperBolNumber: shipperBolPayload,
                Shipperbolnumber: shipperBolPayload,
                shipperbolnumber: shipperBolPayload,
                RPlanWarehouse: planWh,
                rPlanWarehouse: planWh,
                RPlanwarehouse: planWh,
                rPlanwarehouse: planWh,
                RPlanLocation: planLoc,
                rPlanLocation: planLoc,
                RPlanlocation: planLoc,
                rPlanlocation: planLoc,
                RCarrier: formFields.R_CARRIER || null,
                RTransportCarrier: formFields.R_TRANSPORTCARRIER || null,
                REquipment: equipmentId,
                rEquipment: equipmentId,
                TruckReference: truckRef,
                truckReference: truckRef,
                Container: formFields.CONTAINER || "",
                EquipmentInterchangeReport: eir,
                equipmentInterchangeReport: eir,
                Comment: formFields.COMMENT || "",
                DeliveryPickupPlannedDateTime: planFromDt,
                deliveryPickupPlannedDateTime: planFromDt,
                DeliveryPickupArriveDateTime: planToDt,
                deliveryPickupArriveDateTime: planToDt,
                DeliveryPickupDepartDateTime: yardArriveDt,
                deliveryPickupDepartDateTime: yardArriveDt,
                TruckArrivalDateTime: dockStartDt,
                truckArrivalDateTime: dockStartDt,
                TruckDepartDateTime: dockEndDt,
                truckDepartDateTime: dockEndDt,
                TransportationYardLeaveDate: yardLeaveDt,
                transportationYardLeaveDate: yardLeaveDt,
                PickByPlanDate: pickByDt,
                pickByPlanDate: pickByDt,
                LoadByPlanDate: loadByDt,
                loadByPlanDate: loadByDt,
                RUnloadPickBy: unloadPickById,
                rUnloadPickBy: unloadPickById,
                RUnloadpickby: unloadPickById,
                runloadpickby: unloadPickById,
                RCheckBy: checkById,
                rCheckBy: checkById,
                RCheckby: checkById,
                rcheckby: checkById,
                RPutAwayBy: putAwayById,
                rPutAwayBy: putAwayById,
                RPutawayby: putAwayById,
                rputawayby: putAwayById,
                RLoadBy: loadByWorkerId,
                rLoadBy: loadByWorkerId,
                RLoadby: loadByWorkerId,
                rloadby: loadByWorkerId,
                RPickBy: pickByWorkerId,
                rPickBy: pickByWorkerId,
                RPickby: pickByWorkerId,
                rpickby: pickByWorkerId,
                RStagingWarehouse: stagingWhId,
                rStagingWarehouse: stagingWhId,
                RStagingwarehouse: stagingWhId,
                rstagingwarehouse: stagingWhId,
                RStagingArea: stagingAreaId,
                rStagingArea: stagingAreaId,
                RStagingarea: stagingAreaId,
                rstagingarea: stagingAreaId,
                PlannedReceivedShippedDateTime: formFields.PLANNEDRECEIVEDSHIPPEDDATETIME || null,
                StagingStartDate: stagingStartDt,
                stagingStartDate: stagingStartDt,
                StagingEndDate: stagingEndDt,
                stagingEndDate: stagingEndDt,
                PlanComment: planComment,
                planComment: planComment,
                Plancomment: planComment,
                plancomment: planComment,
                DeliveryPickupComment: deliveryPickupComment,
                deliveryPickupComment: deliveryPickupComment,
                Deliverypickupcomment: deliveryPickupComment,
                deliverypickupcomment: deliveryPickupComment,
                ...userDefinedCodeApiFields,
                ...userDefinedReferenceApiFields,
            };

            const isUpdate = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
            const endpoint = isUpdate
                ? data.Transaction.UpdateTransactionSchedule
                : data.Transaction.InsertTransactionSchedule;
            const method = isUpdate ? 'put' : 'post';

            const url = `${window._env_.REACT_APP_APIS}/${endpoint}`;
            const resp = await axios[method](url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                }
            });

            const saved = resp?.data;
            if (saved) {
                setformFields((prev) => ({
                    ...prev,
                    ROWID: saved.RowId || saved.rowId || prev.ROWID,
                    R_PROFILE: saved.RProfile || saved.rProfile || prev.R_PROFILE,
                    R_CUSTOMER: saved.RCustomer || saved.rCustomer || prev.R_CUSTOMER,
                    TRANSACTIONNUMBER: saved.TransactionNumber || saved.transactionNumber || saved.transactionnumber || prev.TRANSACTIONNUMBER,
                    SHIPPERBOLNUMBER: shipperBolFromApi(saved) || prev.SHIPPERBOLNUMBER,
                    R_PLANWAREHOUSE:
                        guidFromApi(
                            saved,
                            'RPlanWarehouse',
                            'rPlanWarehouse',
                            'RPlanwarehouse',
                            'rPlanwarehouse'
                        ) ?? prev.R_PLANWAREHOUSE,
                    R_PLANLOCATION:
                        guidFromApi(
                            saved,
                            'RPlanLocation',
                            'rPlanLocation',
                            'RPlanlocation',
                            'rPlanlocation'
                        ) ?? prev.R_PLANLOCATION,
                    R_CARRIER: saved.RCarrier || saved.rCarrier || prev.R_CARRIER,
                    R_TRANSPORTCARRIER: saved.RTransportCarrier || saved.rTransportCarrier || prev.R_TRANSPORTCARRIER,
                    R_EQUIPMENT:
                        guidFromApi(
                            saved,
                            'REquipment',
                            'rEquipment',
                            'requipment'
                        ) ?? prev.R_EQUIPMENT,
                    TRUCKREFERENCE:
                        stringFromApi(
                            saved,
                            'TruckReference',
                            'truckReference',
                            'truckreference'
                        ) ?? prev.TRUCKREFERENCE,
                    CONTAINER: saved.Container || saved.container || prev.CONTAINER,
                    EQUIPMENTINTERCHANGEREPORT:
                        stringFromApi(
                            saved,
                            'EquipmentInterchangeReport',
                            'equipmentInterchangeReport',
                            'equipmentinterchangereport'
                        ) ?? prev.EQUIPMENTINTERCHANGEREPORT,
                    COMMENT: saved.Comment || saved.comment || prev.COMMENT,
                    DELIVERYPICKUPPLANNEDDATETIME:
                        dateTimeFromApi(
                            saved,
                            'DeliveryPickupPlannedDateTime',
                            'deliveryPickupPlannedDateTime',
                            'deliverypickupplanneddatetime'
                        ) ?? prev.DELIVERYPICKUPPLANNEDDATETIME,
                    DELIVERYPICKUPARRIVEDATETIME:
                        dateTimeFromApi(
                            saved,
                            'DeliveryPickupArriveDateTime',
                            'deliveryPickupArriveDateTime',
                            'deliverypickuparrivedatetime'
                        ) ?? prev.DELIVERYPICKUPARRIVEDATETIME,
                    DELIVERYPICKUPDEPARTDATETIME:
                        dateTimeFromApi(
                            saved,
                            'DeliveryPickupDepartDateTime',
                            'deliveryPickupDepartDateTime',
                            'deliverypickupdepartdatetime'
                        ) ?? prev.DELIVERYPICKUPDEPARTDATETIME,
                    TRUCKARRIVALDATETIME:
                        dateTimeFromApi(
                            saved,
                            'TruckArrivalDateTime',
                            'truckArrivalDateTime',
                            'truckarrivaldatetime'
                        ) ?? prev.TRUCKARRIVALDATETIME,
                    TRUCKDEPARTDATETIME:
                        dateTimeFromApi(
                            saved,
                            'TruckDepartDateTime',
                            'truckDepartDateTime',
                            'truckdepartdatetime'
                        ) ?? prev.TRUCKDEPARTDATETIME,
                    TRANSPORTATIONYARDLEAVEDATE:
                        dateTimeFromApi(
                            saved,
                            'TransportationYardLeaveDate',
                            'transportationYardLeaveDate',
                            'transportationyardleavedate'
                        ) ?? prev.TRANSPORTATIONYARDLEAVEDATE,
                    PICKBYPLANDATE:
                        dateTimeFromApi(
                            saved,
                            'PickByPlanDate',
                            'pickByPlanDate',
                            'pickbyplandate'
                        ) ?? prev.PICKBYPLANDATE,
                    LOADBYPLANDATE:
                        dateTimeFromApi(
                            saved,
                            'LoadByPlanDate',
                            'loadByPlanDate',
                            'loadbyplandate'
                        ) ?? prev.LOADBYPLANDATE,
                    R_UNLOADPICKBY:
                        guidFromApi(
                            saved,
                            'RUnloadPickBy',
                            'rUnloadPickBy',
                            'runloadpickby'
                        ) ?? prev.R_UNLOADPICKBY,
                    R_CHECKBY:
                        guidFromApi(
                            saved,
                            'RCheckBy',
                            'rCheckBy',
                            'rcheckby'
                        ) ?? prev.R_CHECKBY,
                    R_PUTAWAYBY:
                        guidFromApi(
                            saved,
                            'RPutAwayBy',
                            'rPutAwayBy',
                            'rputawayby'
                        ) ?? prev.R_PUTAWAYBY,
                    R_LOADBY:
                        guidFromApi(
                            saved,
                            'RLoadBy',
                            'rLoadBy',
                            'rloadby'
                        ) ?? prev.R_LOADBY,
                    R_PICKBY:
                        guidFromApi(
                            saved,
                            'RPickBy',
                            'rPickBy',
                            'rpickby'
                        ) ?? prev.R_PICKBY,
                    R_STAGINGWAREHOUSE:
                        guidFromApi(
                            saved,
                            'RStagingWarehouse',
                            'rStagingWarehouse',
                            'rstagingwarehouse'
                        ) ?? prev.R_STAGINGWAREHOUSE,
                    R_STAGINGAREA:
                        guidFromApi(
                            saved,
                            'RStagingArea',
                            'rStagingArea',
                            'rstagingarea'
                        ) ?? prev.R_STAGINGAREA,
                    PLANNEDRECEIVEDSHIPPEDDATETIME: saved.PlannedReceivedShippedDateTime || saved.plannedReceivedShippedDateTime || prev.PLANNEDRECEIVEDSHIPPEDDATETIME,
                    STAGINGSTARTDATE:
                        dateTimeFromApi(
                            saved,
                            'StagingStartDate',
                            'stagingStartDate',
                            'stagingstartdate'
                        ) ?? prev.STAGINGSTARTDATE,
                    STAGINGENDDATE:
                        dateTimeFromApi(
                            saved,
                            'StagingEndDate',
                            'stagingEndDate',
                            'stagingenddate'
                        ) ?? prev.STAGINGENDDATE,
                    PLANCOMMENT:
                        stringFromApi(
                            saved,
                            'PlanComment',
                            'planComment',
                            'Plancomment',
                            'plancomment'
                        ) ?? prev.PLANCOMMENT,
                    DELIVERYPICKUPCOMMENT:
                        stringFromApi(
                            saved,
                            'DeliveryPickupComment',
                            'deliveryPickupComment',
                            'Deliverypickupcomment',
                            'deliverypickupcomment'
                        ) ?? prev.DELIVERYPICKUPCOMMENT,
                    ...Object.fromEntries(
                        Array.from({ length: 10 }, (_, idx) => {
                            const n = idx + 1;
                            const field = `USERDEFINEDCODE${n}`;
                            return [
                                field,
                                userDefinedCodeFromApi(saved, n) ?? prev[field],
                            ];
                        })
                    ),
                    ...Object.fromEntries(
                        Array.from({ length: 10 }, (_, idx) => {
                            const n = idx + 1;
                            const field = `USERDEFINEDREFERENCE${n}`;
                            return [
                                field,
                                userDefinedReferenceFromApi(saved, n) ?? prev[field],
                            ];
                        })
                    ),
                }));
            }

            const rowIdAfterSave =
                resp?.data?.RowId ||
                resp?.data?.rowId ||
                formFields.ROWID;
            if (
                rowIdAfterSave &&
                rowIdAfterSave !== '00000000-0000-0000-0000-000000000000'
            ) {
                await loadScheduleById(rowIdAfterSave);
            }

            notify("Schedule saved successfully.", "success", 3000);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                (typeof err?.response?.data === "string" ? err.response.data : null) ||
                err?.message ||
                "Failed to save schedule.";

            notify(message, "error", 5000);
        } finally {
            hideLoadPanel();
        }
    };

    const addNewRecordClick = () => {
        setformFields(initialFormFields);
    };

    const handleReset = () => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadScheduleById(rowId);
        } else {
            setformFields(initialFormFields);
        }
    };

    const goBack = () => {
        history.push("/wm/schedulesmanagement");
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Transaction Schedule
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="Details" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <DetailTab
                                        formFields={formFields}
                                        accessToken={accessToken}
                                    />
                                </TabItem>
                                <TabItem title="Comments">
                                    <CommentsTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                            </TabPanel>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);
